import { ToastProvider } from "@bafe/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import "./app.css";
import "./platform.css";
import { RootErrorBoundary } from "./components/RootErrorBoundary.js";
import { redirectMisinstalledWebmailPwa } from "./lib/misinstalled-webmail-pwa.js";
import { queryClient } from "./lib/query";
import { applyStoredTheme } from "./lib/stores";
import { router } from "./router";

applyStoredTheme();
redirectMisinstalledWebmailPwa();

const container = document.getElementById("root");
if (!container) throw new Error("The #root element is missing from index.html");

createRoot(container).render(
	<StrictMode>
		<RootErrorBoundary>
			<QueryClientProvider client={queryClient}>
				<ToastProvider>
					<RouterProvider router={router} />
				</ToastProvider>
			</QueryClientProvider>
		</RootErrorBoundary>
	</StrictMode>,
);
